import { ChatsList } from './ChatsList';
import { ChatsShow } from './ChatsShow';

export default {
  list: ChatsList,
  show: ChatsShow,
};
